<p
  class="text-sm font-medium"
  [class.text-grey]="!invert"
  [class.text-white]="invert"
  [shabicTextAlign]="align"
>
  <ng-content></ng-content>
</p>
